import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPrinter(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path fill="currentColor" d="M26.25 11.75H21.75L21.75 14.25H26.25L26.25 11.75Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.75 3C5.75 2.30964 6.30964 1.75 7 1.75L25 1.75C25.6904 1.75 26.25 2.30964 26.25 3V7.75L29 7.75C29.6904 7.75 30.25 8.30964 30.25 9L30.25 21C30.25 21.6904 29.6904 22.25 29 22.25H25.25V29C25.25 29.6904 24.6904 30.25 24 30.25L8 30.25C7.30964 30.25 6.75 29.6904 6.75 29L6.75 22.25H3C2.30964 22.25 1.75 21.6904 1.75 21L1.75 9C1.75 8.30964 2.30964 7.75 3 7.75L5.75 7.75L5.75 3ZM6.75 19.75V18C6.75 17.3096 7.30964 16.75 8 16.75L24 16.75C24.6904 16.75 25.25 17.3096 25.25 18V19.75H27.75L27.75 10.25L4.25 10.25L4.25 19.75H6.75ZM23.75 4.25V7.75L8.25 7.75V4.25L23.75 4.25ZM9.25 27.75V19.25L22.75 19.25V27.75L9.25 27.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPrinter);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
